import { render } from "./AdminCreateTicket.vue?vue&type=template&id=b971a788&scoped=true"
import script from "./AdminCreateTicket.vue?vue&type=script&lang=js"
export * from "./AdminCreateTicket.vue?vue&type=script&lang=js"

import "./AdminCreateTicket.vue?vue&type=style&index=0&id=b971a788&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b971a788"]])

export default __exports__